import { render, staticRenderFns } from "./ServiceOrderList.vue?vue&type=template&id=2e404cad&"
import script from "./ServiceOrderList.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports